export default __webpack_public_path__ + "static/media/goshen13.9c20dde4.jpg";